export default __webpack_public_path__ + "static/media/logo-niubiz.a7b30c61.png";